import type { ID, WithId } from '@octopus-do/octopus-project-core'
import { ThemeColors, TinyDropdownMenu } from '@octopus-do/octopus-storybook'
import type React from 'react'

import { createSwitch } from '@/utils'
import { useThreadAccess } from '../../hooks'
import { CommentSettingsTrigger } from '../CommentSettingsTrigger'
import { Content } from './components'
import { useCommentActions } from './hooks'

interface Props extends WithId {
  setEdit: () => void
  className?: string
  author: ID
}

export const CommentActions: React.FC<Props> = ({
  id,
  setEdit,
  className,
  author,
}) => {
  const { onDelete } = useCommentActions(id)

  const canEdit = useThreadAccess(author, 'edit')
  const canDelete = useThreadAccess(author, 'delete')

  if (!canEdit && !canDelete) {
    return null
  }

  const switcher = createSwitch()
    .case(['edit'], setEdit)
    .case(['delete'], onDelete)

  const onClick = (keys: string[]) => switcher.run(keys)

  return (
    <TinyDropdownMenu.Root
      onClick={onClick}
      content={Content}
      sideOffset={8}
      theme={ThemeColors.light}
      canEdit={canEdit}
      canDelete={canDelete}
    >
      <CommentSettingsTrigger className={className} />
    </TinyDropdownMenu.Root>
  )
}
